export const UNIQUE_COMPANIES = '# UNIQUE COMPANIES';
export const MATCHED_COMPANIES = '# MATCHED COMPANIES';
export const NEW_NEW_COMPANIES = '# NET NEW COMPANIES';
export const CREATED = 'Created On';
export const NEW = 'NEW';
export const MY_SEGMENT_FILTER_REVENUE = 'Revenue';
export const MY_SEGMENT_FILTER_EMPLOYEES = 'Employees';
